// -----------------------------------------------------------------------------
// useProducts — Écoute temps réel des produits Firestore (Soft Delete inclus)
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { useState, useEffect } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
} from "firebase/firestore";

import { db, PRODUCTS_COL } from "../firebase";

/**
 * Écoute en temps réel les produits d'un restaurant donné.
 * Filtre automatiquement les produits soft-deleted.
 *
 * @param {string|null} restaurantId - ID du restaurant (null si non connecté)
 * @returns {{ products: Array, error: Error|null }}
 */
export function useProducts(restaurantId) {
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!restaurantId) {
      setProducts([]);
      setError(null);
      return;
    }

    const q = query(
      collection(db, PRODUCTS_COL),
      where("restaurantId", "==", restaurantId),
      where("isDeleted", "==", false),
      orderBy("createdAt", "desc")
    );

    const unsub = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setProducts(data);
        setError(null);
      },
      (err) => {
        console.error("Firestore products error:", err);
        setError(err);
      }
    );

    return unsub;
  }, [restaurantId]);

  return { products, error };
}
